import React from 'react';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'utils/types';

import { actions as addressActions } from 'state/addresses';
import { debouncedAction } from 'utils/debounce';

import addressesSelectors from 'state/addresses/selectors';

import AddressLineFieldComponent from 'components/AddressModal/components/AddressLineField/component';
import { constants as addressesConstants } from 'utils/addresses';

const runDebouncedAction = debouncedAction(
  addressesConstants.DEBOUNCE_SEARCH_INTERVAL
);

const enhance = compose(
  withState('focused', 'setFocused', false),
  withState('pasted', 'setPasted', false),
  withTranslation('AddressFormModal'),
  connect(
    (state) => ({
      loadedAddressesOfInterest:
        addressesSelectors.getLoadedAddressesOfInterest(state),
    }),
    {
      searchAddressOfInterest: addressActions.searchAddressesOfInterest,
      clearAddressesOfInterest: addressActions.clearAddressesOfInterest,
      searchStructuredAddress: addressActions.searchStructuredAddress,
    }
  ),
  withProps(
    ({
      addressSuggestionsEnabled = true,
      zipcode,
      country,
      city,
      loadedAddressesOfInterest,
      error,
      invalid,
      addressLine,
    }) => ({
      addressSuggestionsEnabled,
      zipcode,
      country,
      city,
      addresses: loadedAddressesOfInterest,
      error,
      invalid,
      addressLine,
      names: addressesConstants.FIELDS_NAMES,
    })
  ),
  withHandlers(() => {
    let modalRef = React.createRef();
    let inputRef = React.createRef();
    let inputModalRef = React.createRef();
    return {
      handleSuggestionSelected:
        ({ setFocused, onSuggestionClick }) =>
        (addressSuggestion) => {
          if (modalRef && modalRef.close) modalRef.close();
          setFocused(false);
          onSuggestionClick(addressSuggestion);
        },
      handleInputFocus:
        ({ setFocused }) =>
        () => {
          if (!inputRef || isEmpty(inputRef)) return;

          setFocused(true);
          inputRef.focus();
        },
      handleInputModalFocus:
        ({ setFocused }) =>
        () => {
          if (!inputModalRef || isEmpty(inputModalRef)) return;

          setFocused(true);
          inputModalRef.focus();
        },
      handleInputBlur:
        ({ setFocused, clearAddressesOfInterest }) =>
        () => {
          setFocused(false);
          clearAddressesOfInterest();
        },
      responsiveModalRef: () => (ref) => {
        modalRef = ref;
      },
      inputRef:
        ({ setPasted }) =>
        (ref) => {
          inputRef = ref;
          if (inputRef) {
            inputRef.addEventListener('paste', () => {
              setPasted(true);
            });
          }
        },
      inputModalRef: () => (ref) => {
        inputModalRef = ref;
      },
      handleChange:
        ({
          addressSuggestionsEnabled,
          searchAddressOfInterest,
          onChange,
          zipcode,
          country,
          city,
          setPasted,
        }) =>
        (_, { name, value }) => {
          if (addressSuggestionsEnabled) {
            runDebouncedAction(
              { text: value, postalCode: zipcode, countryCode: country, city },
              searchAddressOfInterest
            );
          }
          onChange(_, {
            name,
            value: value || '',
          });
          setPasted(false);
        },
    };
  })
);

const AddressLineField = enhance(AddressLineFieldComponent);

export default AddressLineField;
